<div class="space-y-6">
  <div>
    <h2 class="mb-2 text-xl font-semibold text-gray-900">
      {{ 'contribute.certificateDetails.title' | transloco }}
    </h2>
    <p class="text-gray-600">
      {{ 'contribute.certificateDetails.description' | transloco }}
    </p>
  </div>

  <!-- Two Column Layout -->
  <div class="grid grid-cols-1 gap-6 lg:grid-cols-5">
    <!-- Left Column: Form Inputs -->
    <div class="space-y-6 lg:col-span-2">
      <!-- Certificate Recipient Name -->
      <div>
        <label for="recipientName" class="mb-2 block font-medium text-gray-700">
          {{ 'contribute.certificateDetails.recipientName' | transloco }} *
        </label>
        <input
          id="recipientName"
          type="text"
          pInputText
          [(ngModel)]="recipientName"
          (ngModelChange)="onRecipientNameChange($event)"
          placeholder="{{ 'contribute.certificateDetails.recipientNamePlaceholder' | transloco }}"
          class="w-full"
        />
        <p class="mt-1 text-sm text-gray-500">
          {{ 'contribute.certificateDetails.recipientNameHint' | transloco }}
        </p>
      </div>

      <!-- Certificate Message -->
      <div>
        <label for="message" class="mb-2 block font-medium text-gray-700">
          {{ 'contribute.certificateDetails.message' | transloco }}
          <span class="font-normal text-gray-400">({{ 'common.optional' | transloco }})</span>
        </label>
        <textarea
          id="message"
          pTextarea
          [(ngModel)]="message"
          (ngModelChange)="onMessageChange($event)"
          placeholder="{{ 'contribute.certificateDetails.messagePlaceholder' | transloco }}"
          [rows]="4"
          [autoResize]="true"
          class="w-full"
        ></textarea>
        <p class="mt-1 text-sm text-gray-500">
          {{ message.length }}/150 {{ 'contribute.certificateDetails.characters' | transloco }}
        </p>
      </div>
    </div>

    <!-- Right Column: Certificate Preview (Sticky) -->
    <div class="lg:col-span-3 lg:sticky lg:top-4 lg:self-start">
      <div class="overflow-hidden rounded-lg border border-greyscale-200">
        <div class="bg-primary-100 p-4">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold text-primary-700">{{ 'contribute.certificateDetails.preview' | transloco }}</h3>
            <span class="rounded-full bg-primary-200 px-2 py-0.5 text-xs font-medium text-primary-700">{{ 'contribute.certificateDetails.live' | transloco }}</span>
          </div>
        </div>
        <div #previewContainer class="certificate-preview-container">
          <div #previewWrapper class="certificate-preview-wrapper">
            <iframe
              [src]="previewUrl() | safeUrl"
              class="certificate-iframe"
              title="Certificate Preview"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation -->
  <div class="flex justify-between pt-4">
    <button
      pButton
      icon="pi pi-arrow-left"
      severity="secondary"
      (click)="onBack()"
    >
      {{ 'common.back' | transloco }}
    </button>
    <button
      pButton
      icon="pi pi-arrow-right"
      iconPos="right"
      [disabled]="!wizardService.canProceedStep3()"
      (click)="onNext()"
    >
      {{ 'common.next' | transloco }}
    </button>
  </div>
</div>
